import React from 'react';
import { VideoSegment, Segment } from './types';
import SegmentVisualization from './SegmentVisualization';

// Component for video timeline slider
interface VideoTimelineSliderProps {
    currentTime: number;
    videoDuration: number;
    onTimeChange: (time: number) => void;
    onMouseDown: () => void;
    onMouseUp: () => void;
    formatTimeDisplay: (seconds: number) => string;
    segments: VideoSegment[];
    onSegmentClick: (segment: VideoSegment) => void;
    videoAnnotationSegments?: Segment[];
}

const VideoTimelineSlider: React.FC<VideoTimelineSliderProps> = ({
    currentTime,
    videoDuration,
    onTimeChange,
    onMouseDown,
    onMouseUp,
    formatTimeDisplay,
    segments,
    onSegmentClick,
    videoAnnotationSegments
}) => {
    const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newTime = parseFloat(e.target.value);
        onTimeChange(newTime);
    };

    return (
        <div style={{ 
            width: '100%', 
            margin: '10px 0', 
            padding: '10px',
            backgroundColor: '#f5f5f5',
            borderRadius: '5px',
            border: '1px solid #ddd'
        }}>
            <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                marginBottom: '8px'
            }}>
                <span style={{ 
                    fontSize: '14px', 
                    fontWeight: 'bold',
                    minWidth: '45px'
                }}>
                    {formatTimeDisplay(currentTime)}
                </span>
                
                <span style={{ 
                    fontSize: '14px',
                    color: '#666',
                    minWidth: '45px'
                }}>
                    {formatTimeDisplay(videoDuration)}
                </span>
            </div>
            
            {/* Full-width slider to match SegmentVisualization */}
            <div style={{ 
                position: 'relative',
                width: '100%',
                height: '20px',
                marginBottom: '8px'
            }}>
                <input
                    type="range"
                    min="0"
                    max={videoDuration || 100}
                    step="0.1"
                    value={currentTime}
                    onChange={handleSliderChange}
                    onMouseDown={onMouseDown}
                    onMouseUp={onMouseUp}
                    onTouchStart={onMouseDown}
                    onTouchEnd={onMouseUp}
                    onFocus={(e) => e.target.blur()}
                    className="video-timeline-slider"
                    style={{
                        width: '100%',
                        height: '20px',
                        background: 'transparent',
                        outline: 'none',
                        cursor: 'pointer'
                    }}
                />
            </div>

            {/* Segment visualization below timeline */}
            <SegmentVisualization
                segments={segments}
                videoDuration={videoDuration}
                onSegmentClick={onSegmentClick}
                formatTimeDisplay={formatTimeDisplay}
                videoAnnotationSegments={videoAnnotationSegments}
            />
            
      
        </div>
    );
};

export default VideoTimelineSlider;